import { Table } from 'antd';
import React from 'react';
import moment from "moment";

import config from "../../config.json";
import useChangeLogs from './../../hooks/useChangeLogs';

// Keys
/* Should be "Id" prop (in quotes) to be mapped to C# Dictionary<string, string>,
also in PascalCase due to entity prop case */
export const getContractChangeLogsKey = (contractId) => ["ContractDetail", "ProductID", { "ContractId": contractId, "PositionID": "1" }];

function ContractChangesHistoryTable({ contractId }) {
    const keys = getContractChangeLogsKey(contractId);
    const { data, isLoading } = useChangeLogs(keys[0], keys[1], keys[2]);

    const columns = [
        { 
            title: 'Fecha',
            dataIndex: 'dateTime',
            render: (value) => moment(value).format(config.dateTimeFormat),
            sorter: (a, b) => moment(a.date) - moment(b.date),
            defaultSortOrder: 'descend',
            width: 180
        },
        { title: 'Val. anterior', dataIndex: 'previousValue' },
        { title: 'Val. nuevo', dataIndex: 'newValue' },
        { title: 'Usuario', dataIndex: 'userName' },
    ];

    return <Table
        rowKey="id"
        style={{ overflowX: "scroll" }}
        loading={isLoading}
        columns={columns}
        dataSource={data}
        pagination={{ hideOnSinglePage: true }} />
}

export default ContractChangesHistoryTable;